import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import { HasRunbooksInGit, HasVariablesInGit } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import CannotCommitCallout from "~/areas/projects/components/VersionControl/CannotCommitCallout";
import { useProjectContext } from "~/areas/projects/context/index";
export function GitCallouts(props: {
    isVariablesPage?: boolean;
    isRunbooksPage?: boolean;
}) {
    const projectContext = useProjectContext();
    if (props.isVariablesPage && !HasVariablesInGit(projectContext.state.model.PersistenceSettings))
        return null;
    if (props.isRunbooksPage && !HasRunbooksInGit(projectContext.state.model.PersistenceSettings))
        return null;
    return (<div className={calloutsStyles}>
            <CannotCommitCallout gitRef={projectContext.state.gitRef}/>
        </div>);
}
const calloutsStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: space["8"],
});
